import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73944653"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menu-icon-list" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["onMouseenter"]
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  style: {"position":"absolute","bottom":"28px"}
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "menu-item-list" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["onClick", "onMouseenter"]
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  style: {"margin-left":"30px"},
  class: "menu-item-label"
}
const _hoisted_12 = {
  key: 1,
  class: "w-full",
  style: {"position":"absolute","bottom":"-50px"}
}
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  style: {"margin-left":"30px"},
  class: "menu-item-label"
}

import i18n from '@/locale/i18n';
import { useLayout } from '@/utils/layout';
import router from '@/router';

import { useRoute } from 'vue-router';

import { ref } from 'vue';
import { useAuthStore } from '@/store/auth';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppSideBar',
  emits: ["sideBarClick"],
  setup(__props, { emit }) {

const t = i18n.global.t;

const route = useRoute();

const auth = useAuthStore();

const categoryStr = ref('');



const { layoutConfig, layoutState, setActiveMenuItem, showLeftbarMenu, hideLeftbarMenu } = useLayout();

const checkActiveCategory = (categoryMenu: any) => {
    let result = false;
    categoryMenu.items.forEach(($i: any) => {
        if (route.path === $i.path) {
            result = true;
        }
    });
    return result;
};

const checkActiveMasterCategory = (categoryMenu: any) => {
    let result = false;
    categoryMenu.forEach((item: any) => {
        item.items.forEach(($i: any) => {
            if (route.path === $i.path) {
                result = true;
            }
        })
    });
    return result;
};

const leftMenuIconOnClick = (event: any) => {
    event.preventDefault();

}

const leftMenuOnClick = (event: any, category: string, section: string) => {
    event.preventDefault();
    if (section === 'SECTION01') {
        if (category === 'ダッシュボード') {
            setActiveMenuItem(category);
            // router.push('/')
        } else {
            if (category !== layoutConfig.activeMenuItem.value) {
                setActiveMenuItem(category);
            } else {
                // setActiveMenuItem(null);
            }
        }
    } else if (section === 'SECTION02') {
        if (category !== layoutConfig.activeMenuItem.value) {
            setActiveMenuItem(category);
        } else {
            // setActiveMenuItem(null);
        }
    }
    hideLeftbarMenu();
    emit('sideBarClick');
}

const leftMenuAnimating = ref(false);

const onMouseOver = (event: any) => {
    event.preventDefault();

    if (!leftMenuAnimating.value) {
        showLeftbarMenu();

        leftMenuAnimating.value = true;
    }
}

const leftMenuOnMouseLeave = () => {
    if (!leftMenuAnimating.value) {
        hideLeftbarMenu();
    }
}

const leftMenubarOnShow = () => {
    leftMenuAnimating.value = false;
}

const leftMenubarOnHide = () => {
    leftMenuAnimating.value = false;
}

const getSection01Menus = () => {
    let temArr: any[] = [];
    auth.menus?.forEach(item => {
        if (item.section == 'SECTION01') {
            temArr.push(item);
        }
    })
    return temArr;
}

const getSection02Menus = () => {
    let temArr: any[] = [];
    auth.menus?.forEach(item => {
        if (item.section == 'SECTION02') {
            temArr.push(item);
        }
    })
    return temArr;
}

const getIcon = (filename: string, show: boolean, category: string) => {
    // if ((show || categoryStr.value === category) && filename) {
    //     const dotIndex = filename.lastIndexOf('.');
    //     const baseName = filename.slice(0, dotIndex);
    //     const newFilename = `${baseName}-white.png`;  
    //     return newFilename; 
    // } else {
    //     return filename;
    // }
    return filename;
}

const onMouseEnter = (category: string) => {
    categoryStr.value = category;
}

const onMouseLeave = () => {
    categoryStr.value = '';
}


return (_ctx: any,_cache: any) => {
  const _component_Sidebar = _resolveComponent("Sidebar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "layout-leftbar",
      onMouseover: onMouseOver
    }, [
      _createElementVNode("div", _hoisted_1, [
        (_unref(auth).user !== null)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getSection01Menus(), (item) => {
                return (_openBlock(), _createElementBlock("li", { key: item }, [
                  _createElementVNode("a", {
                    onClick: leftMenuIconOnClick,
                    class: _normalizeClass({ 'active-route': checkActiveCategory(item) }),
                    style: {"display":"flex","justify-content":"center","align-items":"center","width":"48px","height":"48px","padding":"0"},
                    onMouseenter: ($event: any) => (onMouseEnter(item.category)),
                    onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (onMouseLeave()))
                  }, [
                    _createElementVNode("img", {
                      src: getIcon(item.icon, checkActiveCategory(item), item.category),
                      style: {"width":"40px","height":"40px"}
                    }, null, 8, _hoisted_4)
                  ], 42, _hoisted_3)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_unref(auth).user !== null && getSection02Menus().length>0)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  onClick: leftMenuIconOnClick,
                  class: _normalizeClass({ 'active-route': checkActiveMasterCategory(getSection02Menus()) }),
                  onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (onMouseLeave())),
                  style: {"display":"flex","justify-content":"center","align-items":"center","width":"48px","height":"48px","padding":"0"},
                  onMouseenter: _cache[2] || (_cache[2] = ($event: any) => (onMouseEnter('MASTER')))
                }, [
                  _createElementVNode("img", {
                    src: getIcon('images/sidebar/master.png', checkActiveMasterCategory(getSection02Menus()), 'MASTER'),
                    style: {"width":"40px","height":"40px"}
                  }, null, 8, _hoisted_6)
                ], 34)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ], 32),
    _createVNode(_component_Sidebar, {
      visible: _unref(layoutState).leftbarMenuVisible.value,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((_unref(layoutState).leftbarMenuVisible.value) = $event)),
      position: "left",
      transitionOptions: '.3s cubic-bezier(0, 0, 0.2, 1)',
      modal: false,
      showCloseIcon: false,
      class: "layout-leftbar-sidebar w-20rem",
      onShow: leftMenubarOnShow,
      onHide: leftMenubarOnHide,
      onMouseleave: _withModifiers(leftMenuOnMouseLeave, ["stop"])
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          (_unref(auth).user !== null)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getSection01Menus(), (item) => {
                  return (_openBlock(), _createElementBlock("li", { key: item }, [
                    _createElementVNode("a", {
                      style: {"font-size":"16px","font-family":"Inter","height":"50px","font-weight":"700"},
                      onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (onMouseLeave())),
                      onClick: (evnet) => leftMenuOnClick(evnet, item.category, 'SECTION01'),
                      class: _normalizeClass({ 'active-route': checkActiveCategory(item) }),
                      onMouseenter: ($event: any) => (onMouseEnter(item.category))
                    }, [
                      _createElementVNode("img", {
                        src: getIcon(item.icon, checkActiveCategory(item), item.category),
                        class: "menu-icon-item",
                        style: {"width":"40px","height":"40px"}
                      }, null, 8, _hoisted_10),
                      _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(t)(item.label)), 1)
                    ], 42, _hoisted_9)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_unref(auth).user !== null && getSection02Menus().length>0)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_12, [
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    style: {"font-size":"16px","font-family":"Inter","height":"50px","font-weight":"700"},
                    onMouseleave: _cache[4] || (_cache[4] = ($event: any) => (onMouseLeave())),
                    onClick: _cache[5] || (_cache[5] = (evnet) => leftMenuOnClick(evnet, 'MASTER', 'SECTION02')),
                    class: _normalizeClass({ 'active-route': checkActiveMasterCategory(getSection02Menus()) }),
                    onMouseenter: _cache[6] || (_cache[6] = ($event: any) => (onMouseEnter('MASTER')))
                  }, [
                    _createElementVNode("img", {
                      src: getIcon('images/sidebar/master.png', checkActiveMasterCategory(getSection02Menus()), 'MASTER'),
                      class: "menu-icon-item",
                      style: {"width":"40px","height":"40px"}
                    }, null, 8, _hoisted_13),
                    _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(t)('SIDE_MENU.MASTER')), 1)
                  ], 34)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["visible", "transitionOptions", "onMouseleave"])
  ], 64))
}
}

})